var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAtom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.94 38.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_atom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.87,43.14c-4.46,0-6.79-9.6-6.79-19.1S20.41,5,24.87,5s6.79,9.6,6.79,19.09S29.32,43.14,24.87,43.14ZM24.87,7c-2,0-4.79,6.5-4.79,17.09s2.79,17.1,4.79,17.1,4.79-6.5,4.79-17.1S26.87,7,24.87,7Z",
    transform: "translate(-7.4 -4.95)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.57,35.41c-2,0-3.51-.55-4.24-1.82C6.1,29.73,13.25,22.91,21.47,18.17a45,45,0,0,1,12.22-5.05c4-.87,6.69-.4,7.72,1.38,2.22,3.86-4.93,10.68-13.15,15.42h0C22.74,33.11,16.65,35.41,12.57,35.41ZM37.16,14.7a14.59,14.59,0,0,0-3,.38A42.72,42.72,0,0,0,22.47,19.9c-9.17,5.29-13.41,11-12.41,12.69s8,.9,17.2-4.4h0c9.18-5.29,13.41-11,12.41-12.69C39.42,15.06,38.63,14.7,37.16,14.7Z",
    transform: "translate(-7.4 -4.95)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.07,34.55c-4,0-9.84-1.8-15.18-4.4a45,45,0,0,1-11-7.31C7.9,20,6.8,17.51,7.7,15.67s3.53-2.49,7.6-1.9a44.78,44.78,0,0,1,12.54,4.17h0a44.48,44.48,0,0,1,11,7.31c3,2.85,4.08,5.32,3.18,7.16C41.3,33.91,39.5,34.55,37.07,34.55Zm-24.41-19c-1.94,0-2.91.48-3.16,1-.34.69.18,2.38,2.76,4.84a42.57,42.57,0,0,0,10.51,7c9.52,4.64,16.59,5,17.46,3.19.34-.69-.18-2.38-2.76-4.84a42.29,42.29,0,0,0-10.51-7h0a42.7,42.7,0,0,0-12-4A16.61,16.61,0,0,0,12.66,15.56Z",
    transform: "translate(-7.4 -4.95)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.47,
    cy: 19.1,
    r: 3.27
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.59,
    cy: 28.52,
    r: 1.82
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.03,
    cy: 23.27,
    r: 1.82
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.99,
    cy: 4.72,
    r: 1.82
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAtom);
export default __webpack_public_path__ + "static/media/ic_atom.d68a2768c94482a8d8d3e34bed163be1.svg";
export { ForwardRef as ReactComponent };